module.exports = __webpack_public_path__ + "assets/img/swiper-3-5.e8f4a913.jpg";